import { useState, useEffect, useCallback } from "react";
import { CatalogSettingDto } from "@swagger/typescript-fetch-goflyer";
import { adminApiService } from "../utils/api";
import { useAuthHeaders } from "./useAuthHeaders";

export const useAdminSettingCatalog = () => {
  const authHeaders = useAuthHeaders();
  const [catalog, setCatalog] = useState<CatalogSettingDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState<string[]>([]);

  const refetch = useCallback(async () => {
    setIsLoading(true);
    try {
      const result =
        await adminApiService.gfAdminUserSettingsControllerGetCatalog(
          undefined,
          authHeaders,
        );
      setCatalog(result);
      const uniqueCategories = Array.from(
        new Set(result.map((s) => String(s.category))),
      );
      setCategories(uniqueCategories);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [authHeaders]);

  useEffect(() => {
    refetch();
  }, []);

  return { catalog, isLoading, categories, refetch };
};
